import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import "./Tabs.css";
import EmployeePolicyTab from "./EmployeePolicyTab";
import { getToken } from "../Util/Authenticate";
import URLconfig from "../Util/URLConfig";
import axios from "axios";
import { useState } from "react";
import { Link } from "react-router-dom";

const useStyles = makeStyles({
  root: {
    background: "#860007",
    "&:hover": {
      background: "#f00",
    },
    "&:active": {
      boxShadow: `#ffff`,
    },
    border: 0,
    color: "white",
  },
});

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      className="w-100"
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

function LinkTab(props) {
  return (
    <Tab
      component="a"
      fullWidth
      onClick={(event) => {
        event.preventDefault();
      }}
      {...props}
    />
  );
}

export default function VerticalTabs() {
  const classes = useStyles();
  const [current, setCurrent] = useState(0);
  const [value, setValue] = useState([]);
  const GetTabs = () => {
    var data = "";
    var config = {
      method: "post",
      url: `${URLconfig.API_BASE_URL}api/Admin/GetallAvaliableTabs`,
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
      data: data,
    };
    axios(config)
      .then(function (response) {
        //console.log("Files API", JSON.stringify(response.data));
        setValue(response.data);
      })
      .catch(function (error) {
        //console.log(error);
      });
  };
  const handleChange = (event, newValue) => {
    setCurrent(newValue);
  };
  useEffect(() => {
    GetTabs();
  }, []);
  // const [value, setValue] = React.useState(0);

  // const handleChange = (event, newValue) => {
  //   setValue(newValue);
  // };

  return (
    <>
      <h3>BUE Policies Portal</h3>
      <h6
        style={{
          color: "darkred",
        }}
      >
        Kindly to open the Policies PDF enter your BUE Password
      </h6>
      <Box
        sx={{
          flexGrow: 1,
          bgcolor: "background.paper",
          display: "flex",
          //height: 1500,
        }}
      >
        <Tabs
          orientation="vertical"
          variant="scrollable"
          value={value}
          onChange={handleChange}
          aria-label="Vertical tabs example"
          sx={{ borderRight: 1, borderColor: "divider" }}
          scrollButtons="on"
        >
          {value.map((data, i) => (
            <LinkTab
              label={data.tabName}
              className={classes.root}
              href="/#/dashboard/personalProfile"
              {...a11yProps(i)}
            />
          ))}
        </Tabs>
        {value.map((data, i) => (
          <TabPanel value={current} index={i}>
            <EmployeePolicyTab tabId={data.tabId} />
          </TabPanel>
        ))}
      </Box>
    </>
  );
}
